<template>
    <li>
        <label class="node">
            <input type="checkbox" :id="node.code" :checked="node.checked" @change="$emit('update-tree', node.code, $event.target.checked)" :indeterminate.prop="node.indeterminate">
            <span :class="{bold: hasChildren}"> {{ node.title }} </span>
            <span class="checkmark"></span>
        </label>
        <ul v-if="hasChildren" class="children">
            <template v-for="child in node.children">
                <Node :key="child.code" :node="child" @update-tree="updateTree"/>
            </template>
        </ul>
    </li>
</template>
<script>
export default {
    name: "Node",
    props: {
        node: {
            type: Object,
            default: () => {}
        }
    },
    computed: {
        hasChildren () {
            return this.node.children && this.node.children.length
        }
    },
    methods: {
        updateTree(code, checked){
            this.$emit('update-tree', code, checked)
        },
    },
}
</script>
<style scoped>
    /* The container */
    .bold {
        font-weight: 700;
    }
    .children {
        margin-left: 2.5em;
    }
    .node {
        display: block;
        position: relative;
        padding: .3em;
        padding-left: 2.5em;
        margin-bottom: 0;
        cursor: pointer;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    /* Hide the browser's default checkbox */
    .node input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;
    }

    /* Create a custom checkbox */
    .checkmark {
        position: absolute;
        top: .3em;
        left: .3em;
        height: 1.5em;
        width: 1.5em;
        background-color:white;
        border: var(--bd-sections);
    }

    /* On mouse-over, add a grey background color */
    .node:hover {
        background-color: var(--bg-sections);
    }
    .node:hover input ~ .checkmark {
        background-color: var(--bg-sections);
    }

    /* When the checkbox is checked, add a blue background */
    /*.node input:checked ~ .checkmark {
    }*/

    /* Create the checkmark/indicator (hidden when not checked) */
    .checkmark:after {
        content: "";
        position: absolute;
        display: none;
    }
    /* Style the checkmark/indicator */
    .node .checkmark:after {        
        display: block;
        border: solid var(--dark-primary);
        border-width: 0;
    }
    /* Show the checkmark when checked */
    .node input:checked ~ .checkmark:after {
        left: 6px;
        top: 2px;
        width: 8px;
        height: 12px;
        border-width: 0 2.5px 2.5px 0;
        -webkit-transform: rotate(40deg);
        -ms-transform: rotate(40deg);
        transform: rotate(40deg);
    }
    .node input:indeterminate ~ .checkmark:after {
        left: 4px;
        top: 9px;
        width: 11px;
        height: 12px;
        border-width: 2.5px 0 0 0;
    }
</style>